import { ApiError } from '$lib/diffusionApi';

export const getOptionalApiErrorDetail = (error: unknown): string | undefined => {
	if (!(error instanceof ApiError)) {
		return undefined;
	}

	const body: unknown = error.body;
	if (typeof body !== 'object' || body === null) {
		return undefined;
	}

	const detail: unknown = Reflect.get(body, 'detail');
	return typeof detail === 'string' ? detail : undefined;
};

export const getApiErrorDetail = (error: unknown): string =>
	getOptionalApiErrorDetail(error) ?? 'Unknown error';
